import React from "react";
import parser from "html-react-parser";
import { Link } from "react-router-dom";
import { imageBaseUrl } from "../../constants/ApiConstants";

export default function IconBoxStyle6({ id, title, image }) {
  return (
    <div className="cs_iconbox cs_style_7">
      <div className="cs_iconbox_icon">
        <img className="h-20 w-20" src={`${imageBaseUrl}${image}`} alt="Icon" />
      </div>
      <h2 className="cs_iconbox_title cs_fs_32">{parser(title)}</h2>
      {/* <p className="cs_iconbox_subtitle m-0">{parser(subTitle)}</p> */}
      <Link to={`/search?categoryId=${id}&title=${encodeURIComponent(title)}`} className="cs_iconbox_btn cs_center">
        <img src="images/icons/arrow_white.svg" alt="Icon" />
        <img src="images/icons/arrow_white.svg" alt="Icon" />
      </Link>
    </div>
  );
}
